var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.999 43.9995H58.999",
    stroke: "#A3A3A3",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 9H76.5C78.822 9 79.983 9 80.958 9.13097C87.689 10.0352 92.9855 15.4399 93.8715 22.3083C94 23.3029 94 24.4877 94 26.8571",
    stroke: "#A3A3A3",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28.7487C4 24.3361 4 22.1297 4.34675 20.2919C5.8732 12.2015 12.2015 5.8732 20.2919 4.34675C22.1297 4 24.3361 4 28.7487 4C30.6821 4 31.6488 4 32.5778 4.0869C36.5832 4.46145 40.3826 6.0352 43.4797 8.60255C44.198 9.19805 44.8815 9.88165 46.2485 11.2487L49 14C53.079 18.0789 55.1185 20.1184 57.5605 21.4771C58.902 22.2235 60.3255 22.813 61.802 23.2339C64.4895 24 67.3735 24 73.142 24H75.0105C88.1725 24 94.753 24 99.031 27.8473C99.4245 28.2012 99.799 28.5757 100.152 28.9692C104 33.2468 104 39.8277 104 52.9895V64C104 82.856 104 92.2845 98.142 98.142C92.2845 104 82.856 104 64 104H44C25.1438 104 15.7158 104 9.85785 98.142C4 92.2845 4 82.856 4 64V28.7487Z",
    stroke: "#A3A3A3",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/Folder_Open.072e956bca191fd84ae357af156bc716.svg";
export { ForwardRef as ReactComponent };